var React = require('react');

function Telechargement (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M12 13L12 9","stroke":"currentColor","strokeWidth":"4","strokeLinecap":"square","key":0}),React.createElement("path",{"d":"M12 18L18 13L6 13L12 18Z","fill":"currentColor","key":1}),React.createElement("path",{"d":"M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z","fill":"currentColor","key":2})]);
}

Telechargement.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Telechargement;

Telechargement.default = Telechargement;
